import { loginRouteWithLastUsedTrailerForRoute } from "../ducks/app/route-login";
import {
  RouteUpdatedNotificationData,
  StopDocumentsAddedNotificationData,
} from "./types";
import { useAppDispatch } from "../redux-store";
import { useNavigate } from "react-router-dom";
import { useParams } from "../pages/SessionsPage/hooks";

export const useHandleRouteUpdatedNotification = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const routeId = (params && params.routeId) || "";

  return async (
    notificationData:
      | RouteUpdatedNotificationData
      | StopDocumentsAddedNotificationData,
    me: any
  ) => {
    console.log("### Route updated notification received", {
      routeId: notificationData.data.routeId,
    });

    const routeIdToLogin = notificationData.data.routeId;

    if (!me) {
      navigate(`/login?routeIdRedirectAndLogin=${routeIdToLogin}`);
      console.log("### User not logged in, implement redirect after login!");
      return;
    }

    if (routeId === routeIdToLogin) {
      console.log("### Already on the route, do nothing");
      return;
    }

    console.log("### Logging in to route");
    dispatch(loginRouteWithLastUsedTrailerForRoute({ routeId: routeIdToLogin }))
      .unwrap()
      .then((drivingUrl) => {
        console.log(
          "### Login successful, getting DRIVING URL to navigate to",
          drivingUrl
        );
        navigate(drivingUrl!);
      })
      .catch(() => {
        // Already reported and shown by the thunk; stay where we are.
      });
  };
};
